import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface PerpsPositionsTableProps {
  positions: any[];
}

function num(v: any): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function PerpsPositionsTable({ positions }: PerpsPositionsTableProps) {
  return (
    <div className="rounded-lg border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Symbol</TableHead>
            <TableHead>Side</TableHead>
            <TableHead className="text-right">Size</TableHead>
            <TableHead className="text-right">Entry</TableHead>
            <TableHead className="text-right">Mark</TableHead>
            <TableHead className="text-right">UPnL</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {positions.map((p, idx) => {
            const pos = p?.position ?? p;
            const coin = pos?.coin ?? pos?.symbol ?? pos?.szi?.coin ?? "-";
            const szi = num(pos?.szi ?? pos?.size ?? pos?.positionSize ?? 0);
            const entry = num(pos?.entryPx ?? pos?.entryPrice ?? pos?.avgPx ?? 0);
            const mark = num(pos?.markPx ?? pos?.markPrice ?? 0);
            const pnl = num(pos?.unrealizedPnl ?? pos?.unrealizedPnlUsd ?? pos?.pnl ?? 0);

            const side = szi >= 0 ? "LONG" : "SHORT";

            return (
              <TableRow key={idx}>
                <TableCell className="font-medium">{coin}</TableCell>
                <TableCell>{side}</TableCell>
                <TableCell className="text-right font-mono">{Math.abs(szi).toLocaleString()}</TableCell>
                <TableCell className="text-right font-mono">{entry ? `$${entry.toLocaleString()}` : "-"}</TableCell>
                <TableCell className="text-right font-mono">{mark ? `$${mark.toLocaleString()}` : "-"}</TableCell>
                <TableCell className="text-right font-mono">{pnl ? `$${pnl.toFixed(2)}` : "-"}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
